<template>
  <section class="section">
    <div class="container">
      <h1 class="title">
        Локација уклoњених возила
      </h1>
      <p class="subtitle">
        Возила која су привремено уклоњена налазе се на локацији: <br />
        Чика Тасина бб - Параћин<br />Телфон 0631076990
      </p>
      <img src="@/assets/images/uklonjena3.jpg" alt="" />

      <h1 class="title">
        Улаз у паркинг
      </h1>
      <img src="@/assets/images/uklonjena4.jpg" alt="" />
    </div>
    <Footer></Footer>
  </section>
</template>

<script>
import Footer from '@/components/Footer.vue'
export default {
  components: {
    Footer
  }
}
</script>

<style></style>
